module.exports = __webpack_public_path__ + "static/media/emoji-sad-svgrepo-com.7a500e00.svg";